import {
  CREATE_INDEX,
  CREATE_PIVOT,
  RESET_PERSONA,
  FILE_UPLOAD,
  GET_COLUMN,
  GET_MAPVIEW,
  GET_REGIONS,
  GET_STORE_NAME,
  GET_TABLE,
  GET_VALUE,
  HANDLE_ERROR,
  LOADING_COMPLETE,
  LOADING_DECREMENT,
  LOADING_INCREMENT,
  PIVOT_COLUMNS,
  PIVOT_REFRESH,
  REFRESH,
  REPORT_REFRESH,
  SET_IDS,
  SET_PERSISTENT_DATASET,
  SET_NON_PERSISTENT_DATASET,
  SET_MAPCOND,
  SET_PROGRESS,
  SET_AUDIENCE_SIZE,
  SET_SPECIFIC_PROGRESS,
  RESET_IDS,
  SET_LOADING_LABEL,
  HANDLE_PERMISSION_ERROR,
  CLEAR_MAIN,
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case 'SET_TMP_SEARCH_RESULTS':
      return {
        ...state,
        tmpSearchResults: action.payload,
      };

    case REFRESH:
      return action.payload;

    case CLEAR_MAIN:
      return action.payload;

    case GET_TABLE:
      return {
        ...state,
        tables: action.payload,
        dbOptions: { ...state.dbOptions, tables: action.payload },
        // loading: false,
      };

    case GET_COLUMN:
      return {
        ...state,
        columns: action.payload,
        dbOptions: { ...state.dbOptions, columns: action.payload },
        // loading: false,
        question: 2,
      };
    case GET_VALUE:
      return {
        ...state,
        values: action.payload,
        dbOptions: { ...state.dbOptions, values: action.payload },
        // loading: false,
        question: 3,
      };

    case GET_MAPVIEW: {
      return {
        ...state,
        defineCus: action.payload,
      };
    }

    // case LOADING:
    //   return {
    //     ...state,
    //     loading: true,
    //   };

    case LOADING_INCREMENT: {
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.type]: (state?.loading[action.payload.type] || 0) + 1,
        },
      };
    }
    case LOADING_DECREMENT: {
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.type]:
            (state?.loading[action.payload.type] - 1 >= 0
              ? state?.loading[action.payload.type] - 1
              : 0) || 0,
        },
      };
    }

    case SET_PROGRESS: {
      return {
        ...state,
        progress: 'customer',
        // loading: true,
      };
    }

    case SET_SPECIFIC_PROGRESS: {
      return {
        ...state,
        progress: action.payload,
        // loading: true,
      };
    }

    case SET_AUDIENCE_SIZE: {
      return {
        ...state,
        audienceSize: action.payload,
      };
    }

    case SET_IDS: {
      return {
        ...state,
        ids: action.payload?.ids,
        audiences: {
          cols: action.payload?.cols,
          sqlWhere: action.payload?.sqlWhere,
        },
        // loading: false,
      };
    }

    case SET_PERSISTENT_DATASET: {
      return {
        ...state,
        dataset: action.payload,
        isPersistentIds: true,
      };
    }

    case SET_NON_PERSISTENT_DATASET: {
      return {
        ...state,
        dataset: action.payload,
        isPersistentIds: false,
      };
    }

    case GET_REGIONS: {
      return {
        ...state,
        regions: action.payload.regions,
      };
    }

    case CREATE_INDEX: {
      return {
        ...state,
        indexdata: action.payload,
        // loading: false,
      };
    }

    case RESET_PERSONA: {
      return {
        ...state,
        indexdata: null,
        demSummary: {},
        pivotdata: {
          raw: [],
          percentage: [],
          numVar: [],
          index: [],
        },
      };
    }

    case PIVOT_REFRESH: {
      return {
        ...state,
        dbOptions: { ...state.dbOptions, columns: [], values: [] },
        question: 1,
        columns: [],
        values: [],
      };
    }

    case CREATE_PIVOT: {
      return {
        ...state,
        pivotdata: {
          raw: action.payload[0],
          percentage: action.payload[1],
          numVar: action.payload[2],
          index: action.payload[3],
        },
        // loading: false,
      };
    }

    case FILE_UPLOAD: {
      return {
        ...state,
        crm: action.payload,
        // loading: false,
      };
    }

    case PIVOT_COLUMNS: {
      return {
        ...state,
        pivotColumns: action.payload,
      };
    }

    case HANDLE_ERROR: {
      return {
        ...state,
        error: action.payload,
        // loading: false,
      };
    }

    case HANDLE_PERMISSION_ERROR: {
      return {
        ...state,
        permissionError: action.payload,
      };
    }

    case GET_STORE_NAME: {
      return {
        ...state,
        storeName: action.payload.storeName,
        topStoreName: action.payload.topStoreName,
      };
    }

    case REPORT_REFRESH: {
      return {
        ...state,
        mapdata: {},
        ids: null,
      };
    }

    case SET_MAPCOND: {
      return {
        ...state,
        mapcond: action.payload.cond,
        mapcode: action.payload.code,
        mapdisplay: action.payload.display,
        audiencePopulation: action.payload.population,
        qbFields: action.payload.qbFields,
      };
    }

    case LOADING_COMPLETE: {
      return {
        ...state,
        loading: false,
      };
    }

    case 'SET_DATASETS': {
      return {
        ...state,
        datasetsList: {
          ...state.datasetsList,
          [action.payload.country]: action.payload.datasetArr,
        },
        selectedDatasets: action.payload.datasetArr,
      };
    }

    case 'UPDATE_SELECTED_DATASETS': {
      return {
        ...state,
        selectedDatasets: action.payload,
      };
    }

    case 'SET_MAPDATA': {
      return {
        ...state,
        mapdata: action.payload,
      };
    }
    case 'SET_PIVOTDATA': {
      return {
        ...state,
        pivotdata: action.payload.pivotdata,
        pivotCond: action.payload.pivotCond,
      };
    }
    case 'SET_PIVOT_VARS': {
      return {
        ...state,
        pivotVars: action.payload.pivotVars,
        pivotRegion: action.payload.pivotRegion || 'National',
      };
    }
    case 'SET_INDEXDATA': {
      return {
        ...state,
        indexdata: action.payload,
      };
    }

    case 'SET_DEFINECUS': {
      return {
        ...state,
        defineCus: { names: action.payload },
      };
    }

    case 'SET_NICKNAME': {
      return {
        ...state,
        nickname: action.payload,
      };
    }

    case 'SET_STORECOLORS': {
      return {
        ...state,
        storeColors: {
          ...state.storeColors,
          [action.payload.key]: action.payload.colorDetails,
        },
      };
    }

    case 'CLEAR_MAP': {
      return {
        ...state,
        mapdata: {},
      };
    }

    case 'CLEAR_MAP_CACHE': {
      let cache = state.mapdataCache;
      if (action.view === 'ALL') {
        cache = {};
      } else if (cache[action.view]) {
        delete cache[action.view];
      }
      return {
        ...state,
        mapdataCache: cache,
      };
    }

    case 'GET_MOBILITY_DATES': {
      return {
        ...state,
        mobilityDates: action.payload,
      };
    }

    case 'SET_SELECTVARS': {
      return {
        ...state,
        ...action.payload,
        progress: 'reselect',
        mapcond: state.mapcond,
        mapcode: state.mapcode,
        mapdisplay: state.mapdisplay,
        defineCus: state.defineCus,
        audiences: state.audiences,
        audiencePopulation: state.audiencePopulation,
      };
    }

    case 'SET_AUDIENCE_TEMPLATE': {
      return {
        ...state,
        audienceTemplate: {
          advanced: action.payload.advanced,
          cond: action.payload.cond,
          code: action.payload.code,
          display: action.payload.display,
          population: action.payload.population,
          qbFields: action.payload.qbFields,
        },
      };
    }

    case 'SET_MEDIA_USAGE': {
      return {
        ...state,
        // loading: false,
        mediaUsage: action.payload,
      };
    }

    case 'SET_MEDIA_CHANNELS': {
      return {
        ...state,
        mediaChannels: action.payload,
      };
    }

    case 'SET_MUDATA': {
      return {
        ...state,
        mediaUsage: action.payload.mediaUsage,
        mediaChannels: action.payload.mediaChannels,
      };
    }

    case 'GET_DEMPROFILING': {
      return {
        ...state,
        // loading: false,
        demSummary: action.payload,
      };
    }

    case 'SET_COLUMNS': {
      return {
        ...state,
        columns: action.payload,
      };
    }

    case 'SET_CRM_IDS': {
      return {
        ...state,
        ids: action.payload,
      };
    }

    case 'GET_OOH_COMPANY_NAME':
      return {
        ...state,
        oohCompanyName: action.payload,
      };

    case 'GET_OOH_ANALYTICS':
      return {
        ...state,
        oohAnalytics: action.payload,
      };

    case 'GET_RETAIL_FLOWMAP':
      return {
        ...state,
        retailFlowMap: action.payload.flow_map,
      };

    case 'GET_RETAIL_ANALYTICS':
      return {
        ...state,
        oohAnalytics: action.payload,
      };

    case 'GET_FSA_ANALYTICS':
      return {
        ...state,
        fsaAnalytics: action.payload,
      };

    case 'GET_DRIVE_TIME_LAYER':
      return {
        ...state,
        driveTimeLayer: action.payload,
      };

    case 'EXTRACT_OOH': {
      return {
        ...state,
        oohData: {
          ...state.oohData,
          [action.payload.oohType]: action.payload.ooh,
        },
      };
    }

    case 'UPDATE_OOH_SELECTED': {
      return {
        ...state,
        oohData: {
          ...state.oohData,
          [action.payload.brand]: {
            ...state.oohData[action.payload.brand],
            selected: action.payload.selected,
          },
        },
      };
    }

    case 'UPDATE_STORE_SELECTED': {
      return {
        ...state,
        storedata: {
          ...state.storedata,
          [action.payload.brand]: {
            ...state.storedata[action.payload.brand],
            selected: action.payload.selected,
          },
        },
      };
    }

    case 'SET_PROFILING_SEGMENT': {
      return {
        ...state,
        demSummary: {
          ...state.demSummary,
          clusters: action.payload,
        },
      };
    }

    case 'SET_AUDIENCE_COUNT': {
      return {
        ...state,
        demSummary: {
          ...state.demSummary,
          dem_count: action.payload,
        },
      };
    }

    case 'SET_GEO_LOCATION': {
      return {
        ...state,
        geoLocation: action.payload.latitude
          ? {
              latitude: action.payload.latitude,
              longitude: action.payload.longitude,
            }
          : null,
      };
    }

    case 'GET_KML_GEOJSON': {
      return {
        ...state,
        kmlData: action.payload,
      };
    }

    case 'SET_AUDIENCE': {
      return {
        ...state,
        mapcode: action.payload.code,
        mapcond: action.payload.cond,
        mapdisplay: action.payload.display,
      };
    }

    case 'SET_VARIABLE_MAPPING': {
      return {
        ...state,
        variableMapping: action.payload,
      };
    }

    case 'SET_CRM': {
      return {
        ...state,
        CRM: action.payload,
      };
    }

    case RESET_IDS: {
      return {
        ...state,
        ids: null,
      };
    }

    case SET_LOADING_LABEL: {
      return {
        ...state,
        loadingLabels: action.payload,
      };
    }

    default:
      return state;
  }
};
